import { makeStyles } from "@material-ui/core/styles";

const primaryColor = "#83a348";

const useStyles = makeStyles(() => ({
  radio: {
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
    fontSize: "1.125rem",
  },
  dichargeButton: {
    boxShadow: "0 0 0",
    fontSize: "1.2rem",
    borderRadius: 0,
    maxWidth: "150px",
    height: "65px",
    width: "100%",
  },
  searchButton: {
    boxShadow: "0 0 0",
    fontSize: "1.2rem",
    borderRadius: 0,
    maxWidth: "150px",
    height: "55px",
    width: "100%",
  },
  nextButton: {
    boxShadow: "0 0 0",
    fontSize: "1.2rem",
    borderRadius: 0,
    maxWidth: "150px",
    height: "65px",
    width: "100%",
  },
  backButton: {
    boxShadow: "0 0 0",
    fontSize: "1.2rem",
    borderRadius: 0,
    maxWidth: "150px",
    height: "65px",
    width: "100%",
  },
  attachDiv: {
    borderWidth: "2px",
    borderColor: primaryColor,
    // margin: "5px",
    border: "solid",
    borderRadius: "5px",
    padding: "15px",
    marginBottom: "5px",
    marginLeft: "7px",
  },
  inputBox: {
    borderWidth: "2px",
    borderColor: primaryColor,
    border: "solid",
    borderRadius: "5px",
    padding: "15px",
    margin: "3em 0",
  },
  inputBoxTitle: {
    color: primaryColor,
    fontSize: "2em",
  },
  inputBoxSubTitle: {
    color: primaryColor,
    fontSize: "1.5em",
  },
}));

export default useStyles;
